import * as React from "react";
import { forwardRef } from "react";
const SvgText = (props, ref) => /* @__PURE__ */ React.createElement("svg", { height: "current", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 4V1H17V4M6 17H12M9 1V17", stroke: "current", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgText);
export default ForwardRef;
